import { useMutation } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useUpdateRun = () => {
  const { getFetchConfig } = useGetFetchConfig();

  const updateRun = async ({ runId, name }: { runId: string; name: string }) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.PATCH,
      data: { name },
    });

    const response = await fetch(`${APIBaseChronos}/api/run/${runId}`, fetchConfig);
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message);
    }
  };

  return useMutation({
    mutationFn: updateRun,
    onError: () => {
      toast.error('Failed to update run name. Please try again.');
    },
  });
};
